import { GoToAccountSettingsCTA } from "./ctas";
export var WhatIsEoriIA = function WhatIsEoriIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "J4Rz7Z",
    defaultMessage: [{
      "type": 0,
      "value": "Wat is een EORI-nummer?"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VAG9Vi",
    defaultMessage: [{
      "type": 0,
      "value": "Het ‘Economic Operators Registration and Identification’-nummer (EORI) is een uniek nummer dat door bedrijven wordt gebruikt om zich bij de douane te identificeren op douaneaangiften en andere invoerdocumentatie. Een EORI-nummer kan handig zijn om mogelijke vertragingen en opslagkosten te voorkomen als je bestelling niet tijdig door de douane kan worden verwerkt. We raden je daarom aan een EORI-nummer aan te vragen als je goederen uit een ander land importeert. Je kunt je EORI-nummer invoeren onder het gedeelte ‘Import- en belastinggegevens’ op het tabblad Mijn profiel van je pagina Accountinstellingen."
    }]
  });
};